export const POST_POST = 'POST_POST';
export const LIST_POST = 'LIST_POST';
export const GET_POST = 'GET_POST';
export const LIST_POST_SELETO = 'LIST_POST_SELETO';
